<div
  *ngIf="url"
  class="w-100 d-flex flex-column justify-content-center align-items-center h-100"
>
 <iframe class="w-100 flex-grow-1" [src]="url"></iframe>
</div>
